import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModule } from "../../shared/shared.module";
import { UiModule } from "../../ui/ui.module";
import { NotifyModule } from "../../notify/notify.module";
import { MultiSelectModule } from "primeng/multiselect";
import { DialogModule } from "primeng/dialog";
import { QuoteDeclineFormComponent } from "./quote-decline-form.component";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UiModule,
    NotifyModule,
    MultiSelectModule,
    DialogModule,
    QuoteDeclineFormComponent,
  ],
  providers: [],
  exports: [QuoteDeclineFormComponent],
})
export class QuoteDeclineFormModule {}
